// utils/dateFormat.js
import { format, parseISO } from 'date-fns';

import moment from "moment-timezone";

const formatMap = {
    "YYYY/MM/DD": "yyyy/MM/dd",
    "MM/DD/YYYY": "MM/dd/yyyy",
    "DD/MM/YYYY": "dd/MM/yyyy",
    "YYYY-MM-DD": "yyyy-MM-dd",
    "MM-DD-YYYY": "MM-dd-yyyy",
    "DD-MM-YYYY": "dd-MM-yyyy"
};


export function formatDate(dateInput) {
    // console.log("formatDate input:", dateInput, typeof dateInput);

    if (!dateInput) return "";

    try {
        let dateObj;

        if (typeof dateInput === 'string') {
            dateObj = new Date(dateInput);
        } else if (dateInput instanceof Date) {
            dateObj = dateInput;
        } else {
            // console.log("Invalid input type");
            return "";
        }

        if (isNaN(dateObj.getTime())) {
            // console.log("Invalid date");
            return "";
        }

        // Get user preference from localStorage
        let userInfo = {};
        try {
            userInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");
            // console.log("User info from localStorage:", userInfo);
        } catch (e) {
            // console.warn("Could not parse user info from localStorage:", e);
        }

        const userDateFormat = userInfo.dateFormat || "YYYY/MM/DD";
        // console.log("User date format preference:", userDateFormat);

        // Extract date components in Asia/Kolkata timezone to match server-side
        // date calculations (adminTimeZone = "Asia/Kolkata"). This ensures
        // consistency with formatDateTimeWithTZ regardless of browser timezone.
        const m = moment(dateObj).tz("Asia/Kolkata");
        const year = m.year();
        const month = String(m.month() + 1).padStart(2, '0');
        const day = String(m.date()).padStart(2, '0');

        let result;

        // Format according to user preference
        switch (userDateFormat) {
            case "MM/DD/YYYY":
                result = `${month}/${day}/${year}`;
                break;
            case "DD/MM/YYYY":
                result = `${day}/${month}/${year}`;
                break;
            case "YYYY-MM-DD":
                result = `${year}-${month}-${day}`;
                break;
            case "MM-DD-YYYY":
                result = `${month}-${day}-${year}`;
                break;
            case "DD-MM-YYYY":
                result = `${day}-${month}-${year}`;
                break;
            case "YYYY/MM/DD":
            default:
                result = `${year}/${month}/${day}`;
                break;
        }

        // console.log("Formatted result:", result);
        return result;

    } catch (error) {
        console.error("Error formatting date:", error);
        return "";
    }
}
export function formatWaiverDate(dateInput, dateFormat) {
    if (!dateInput) return "";
    try {
        let dateObj;
        if (typeof dateInput === 'string') {
            dateObj = new Date(dateInput);
        } else if (dateInput instanceof Date) {
            dateObj = dateInput;
        } else {
            return "";
        }
        const userDateFormat = dateFormat || "YYYY/MM/DD";
        const year = dateObj.getFullYear();
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const day = String(dateObj.getDate()).padStart(2, '0');

        let result;
        switch (userDateFormat) {
            case "MM/DD/YYYY":
                result = `${month}/${day}/${year}`;
                break;
            case "DD/MM/YYYY":
                result = `${day}/${month}/${year}`;
                break;
            case "YYYY-MM-DD":
                result = `${year}-${month}-${day}`;
                break;
            case "MM-DD-YYYY":
                result = `${month}-${day}-${year}`;
                break;
            case "DD-MM-YYYY":
                result = `${day}-${month}-${year}`;
                break;
            case "YYYY/MM/DD":
            default:
                result = `${year}/${month}/${day}`;
                break;
        }
        return result;
    } catch (error) {
        console.error("Error formatting date:", error);
        return "";
    }
}


export function formatTime(dateInput) {
    if (!dateInput) return "";
    try {
        return moment(dateInput).tz("Asia/Kolkata").format("hh:mm A");
    } catch (error) {
        return "";
    }
}

export function formatDateTimeWithTZ(dateStr) {
    if (!dateStr) return "";

    const userInfo = JSON.parse(localStorage.getItem("loggedUserInfo") || "{}");
    const dateFormat = userInfo.dateFormat || "YYYY/MM/DD";

    // Moment-compatible patterns (with time)
    const dateTimeMap = {
        "DD/MM/YYYY": "DD/MM/YYYY hh:mm:ss A",
        "MM/DD/YYYY": "MM/DD/YYYY hh:mm:ss A",
        "YYYY/MM/DD": "YYYY/MM/DD hh:mm:ss A",
    };

    const formatPattern = dateTimeMap[dateFormat] || "YYYY/MM/DD hh:mm:ss A";

    // 1) Parse the ISO string (UTC) → 2) convert to Asia/Kolkata
    return moment(dateStr).tz("Asia/Kolkata").format(formatPattern);
}
